const TimerTime = ({
  arrowCount,
  timerStyle,
  minutes,
  seconds,
  setMinutes,
  setSeconds,
  saveTime,
  getZero
}) => {
  const Regex = /^\d+$/;

  const handleInputChange = (value, setValue) => {
    const isValid = Regex.test(value);
    if (Number(value) === 0) {
      setValue(value);
      return;
    }
    if (isValid && Number(value) <= 59) {
      setValue(value);
    }
  };

  const handleInputBlur = (value, setValue, defaultValue) => {
    const isValid = Regex.test(value);
    if (isValid) {
      setValue(getZero(value));
    } else {
      setValue(getZero(defaultValue));
    }
    saveTime(minutes, seconds);
  };

  return (
    <>
      <div className={`flex justify-center gap-2.5 w-${timerStyle(arrowCount).timerWidth} bg-gray-20 items-center  rounded-lg ${timerStyle(arrowCount).timerCard}`}
      >
        <div className={'flex items-center gap-1'}>
          <input
            maxLength={2}
            min={0}
            max={59}
            onChange={(e) => handleInputChange(e.target.value, setMinutes, '5')}
            onBlur={(e) => handleInputBlur(e.target.value, setMinutes, '5')}
            value={minutes}
            type="text"
            className={`${timerStyle(arrowCount).textWidth} text-white font-medium ${timerStyle(arrowCount).fontSize} bg-gray-20 outline-none flex items-center`}
          />

          <span className={`text-white ${timerStyle(arrowCount).fontSize} -mt-1`}>:</span>

          <input
            maxLength={2}
            min={0}
            max={59}
            onChange={(e) => handleInputChange(e.target.value, setSeconds, '0')}
            onBlur={(e) => handleInputBlur(e.target.value, setSeconds, '0')}
            value={seconds}
            type="text"
            className={`${timerStyle(arrowCount).textWidth}  bg-gray-20 text-white font-medium ${timerStyle(arrowCount).fontSize} outline-none`}
          />
        </div>

        <span className="text-base font-medium text-neutral-50">Min</span>
      </div>
    </>
  );
};

export default TimerTime;
